<template>
  <v-card style="text-align: center;">
    <v-menu
      offset-y
      class="mt-2"
      dense
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          fab
          x-small
          absolute
          @click.stop=""
          style="top: 5px; right: 5px;"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          dense
          @click="$emit('modify')"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('modify') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          @click="startAddToFolder()"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-folder-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('add_to_folder') }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          @click="deleting = true; deletingMapId = map.id"
          link
          dense
        >
          <v-list-item-icon>
            <v-icon>mdi-delete</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <choose-folder
      v-if="choosingFolder"
      :value="chosenFolder"
      :visible="choosingFolder"
      :text="$t('folder.add_to_folder')"
      @chosen="folderChosen($event)"
      @closed="choosingFolder = false; chosenFolder = null;"
    ></choose-folder>
    <Map
      :hideButtons="true"
      :url="map ? map.url : ''"
      :value="points"
      :maxHeight="200"
      :maxWidth="200"
      :disableClicks="true"
    ></Map>
    <v-card-title>
      {{map.title}}
    </v-card-title>
    <confirmation-dialog
      :show="deleting"
      :text="$t('maps.delete_title')"
      :subText="$t('maps.delete_map_long')"
      btnColor="red"
      @decline="deleting = false; deletingMapId = null"
      @accept="startDeleteMap()"
      :btnText="$t('delete')"
    ></confirmation-dialog>
  </v-card>
</template>

<script>
import Map from '@/components/maps/Map'
import a from '@/utils/axios/axios'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import ChooseFolder from '../folder/ChooseFolder.vue'

import { mapActions } from 'vuex'

export default {
  props: ['map'],
  data: () => ({
    points: [],
    deletingMapId: null,
    deleting: false,
    chosenFolder: null,
    choosingFolder: false
  }),
  components: {
    Map,
    ConfirmationDialog,
    ChooseFolder
  },
  created() {
   
    // a.get(`/maps/${this.map.id}/points`)
    a.get(`/maps/${this.map.id}/points?limit=5`)
      .then(e => this.points = e.data.map(p => {
        return {
          ...p,
          color: 'black'
        }
      }))
      .catch(e => this.error(e))
  },
  methods: {
    ...mapActions('folder', [ 'addFolder' ]),
    ...mapActions('noti', [ 'error', 'info' ]),
    folderChosen(folder) {
      this.addToFolder(folder.id)
    },
    startAddToFolder() {
      this.choosingFolder = true
    },
    addToFolder(parent_id) {
      this.addFolder({
        name: this.map.title,
        type: 'map',
        map_id: this.map.id,
        parent: parent_id
      })
      .then(() => { 
        this.info(this.$t('maps.map_added_to_folder')) 
        this.chosenFolder = null
        this.choosingFolder = false
      })
      .catch(e => this.error(e))
    },
    startDeleteMap() {
      this.$emit('delete')
    }
  }
}
</script>